<template>
    <v-container>
        <v-row align="center" class="mt-3">
            <v-col cols="12" md="7" class="title-page">
                {{ title }}
            </v-col>
            <v-col cols="10" md="4">
                <kimsa-text-field
                    @change="search = $event"
                    :value="search"
                    :placeholder="$t('common.search')"
                    force-value clearable
                    icon="mdi-magnify"
                    :loading="loading"
                />
            </v-col>
            <v-col cols="2" md="1" align="center">
                <v-btn icon @click="refreshCurrentTab">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </v-col>
            <v-col cols="12" class="pt-0">
                <v-divider/>
            </v-col>
            <v-col cols="12">
                <routines
                    @loading="loading = $event"
                    :search="search"
                    no-folder
                    ref="routines"/>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
import Routines from "@/components/coach/routines/Routines";
import Programs from "@/components/coach/routines/Programs";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";

export default {
    components: {KimsaTextField, Routines, Programs},
    data() {
        return {
            tabs: ['routines'],
            currentTab: 'routines',
            search: '',
            loading: false,
        }
    },
    computed: {
        title(vm = this) {
            if (vm.currentTab === 'routines') return vm.$t('coach.review_your_routines')
            return vm.$t('programs.review_your_programs')
        },
    },
    async mounted() {
        const vm = this
        if(vm.$route.query?.tabs === 'programs') vm.currentTab = 'programs'
    },
    methods: {
        refreshCurrentTab() {
            const vm = this
            if(vm.currentTab === 'programs') return vm.$refs.programs.loadPrograms()
            return vm.$refs.routines.loadRoutines()
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            let programRoutes = ['company.routines.program.detail', 'company.routines.program.assign']
            if(programRoutes.includes(from.name)) vm.currentTab = 'programs'
        })
    }
}
</script>

<style scoped>

.title-page {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
}

.tabs-items {
    background-color: transparent;
    padding: 12px 0;
}

</style>
